/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */

import {
    ToolbarButton,
    ColumnsPanelTrigger,
    FilterPanelTrigger,
} from '@mui/x-data-grid-pro'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import Divider from '@mui/material/Divider'

import ExportToolbarMenu
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/ExportToolbarMenu'
import ClearSortingIcon
    from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/components/SkyBaseDataGridToolbar/ClearSortingIcon'
import FilterIcon from 'app/shared-components/FilterIcon'
import useClearSorting from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/hooks/useClearSorting'

import useActiveFiltersCount from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/hooks/useActiveFiltersCount'

import useStyles from '../SkyNetDataGridToolbar.style'
import {
    ToolbarSharedProps,
} from '../SkyNetDataGridToolbar'
import useAllowedToolbarActions from '../hooks/useAllowedToolbarActions'

const DefaultViewToolbarActions = ({
    toolbarControls,
    showFilterButton,
    toolbarActions,
    toolbarActionsProps,
}: Readonly<ToolbarSharedProps>) => {
    const {
        classes,
    } = useStyles()

    const handleClearSorting = useClearSorting()

    const actions = useAllowedToolbarActions({
        toolbarActions,
        toolbarActionsProps,
    })
    const activeFiltersCount = useActiveFiltersCount(showFilterButton)

    return (
        <>
            {actions.map((action, i) => {
                return (
                    <div
                        key={`toolbar-action-${i}`}
                        className={classes.action}
                    >
                        {action}
                    </div>
                )
            })}
            {actions.length > 0 && (
                <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    sx={{
                        ml: 0.2,
                    }}
                />
            )}
            {toolbarControls?.map((control, index) => {
                return <div key={`toolbar-control-${index}`}>{control}</div>
            })}
            {showFilterButton && (
                <Tooltip title="Filters">
                    <FilterPanelTrigger
                        render={(props) => {
                            return (
                                <ToolbarButton
                                    {...props}
                                    color="default"
                                    data-testid="filter-btn"
                                >
                                    <Badge
                                        badgeContent={activeFiltersCount}
                                        color="primary"
                                        variant="dot"
                                    >
                                        <FilterIcon
                                            className={classes.filter}
                                            newStyling
                                        />
                                    </Badge>
                                </ToolbarButton>
                            )
                        }}
                    />
                </Tooltip>
            )}
            <ExportToolbarMenu />
            <Tooltip title="Clear Sorting">
                <ToolbarButton
                    onClick={handleClearSorting}
                    data-testid="clear-sorting-btn"
                >
                    <ClearSortingIcon />
                </ToolbarButton>
            </Tooltip>

            <Tooltip
                title="Columns"
                data-testid="columns-menu"
            >
                <ColumnsPanelTrigger render={<ToolbarButton />}>
                    <ViewColumnIcon fontSize="small" />
                </ColumnsPanelTrigger>
            </Tooltip>
        </>
    )
}

export default DefaultViewToolbarActions
